/**
 * Efeitos.ts — Efeitos efemeros (Fase 6): onda de choque + particulas na captura,
 * pulso curto na torre construida. Vivem na fxLayer (mundo, acima das naves).
 */

import { Graphics, Sprite } from 'pixi.js';
import gsap from 'gsap';
import { texturaPonto } from './Texturas';
import type { PixiApp } from './PixiApp';

export class Efeitos {
  constructor(private readonly pixi: PixiApp) {}

  /** Planeta trocou de dono: anel que se expande + 16 fagulhas na cor do novo dono. */
  explosaoCaptura(x: number, y: number, raio: number, cor: number): void {
    const anel = new Graphics();
    anel.circle(0, 0, raio + 6).stroke({ color: cor, width: 4, alpha: 0.95 });
    anel.circle(0, 0, raio + 14).stroke({ color: 0xffffff, width: 1.5, alpha: 0.6 });
    anel.x = x; anel.y = y;
    anel.blendMode = 'add';
    this.pixi.fxLayer.addChild(anel);
    gsap.to(anel.scale, { x: 3.2, y: 3.2, duration: 0.8, ease: 'power2.out' });
    gsap.to(anel, { alpha: 0, duration: 0.8, ease: 'power1.out', onComplete: () => destruir(anel) });

    const tex = texturaPonto();
    for (let i = 0; i < 16; i++) {
      const p = new Sprite(tex);
      p.anchor.set(0.5);
      p.tint = i % 3 === 0 ? 0xffffff : cor;
      const tam = 4 + Math.random() * 6;
      p.width = tam; p.height = tam;
      p.x = x; p.y = y;
      p.blendMode = 'add';
      this.pixi.fxLayer.addChild(p);
      const ang = (i / 16) * Math.PI * 2 + Math.random() * 0.4;
      const dist = raio + 40 + Math.random() * 90;
      gsap.to(p, {
        x: x + Math.cos(ang) * dist,
        y: y + Math.sin(ang) * dist,
        alpha: 0,
        duration: 0.55 + Math.random() * 0.4,
        ease: 'power2.out',
        onComplete: () => destruir(p),
      });
    }
  }

  /** Torre nova: anel curto na cor do dono. */
  pulsoTorre(x: number, y: number, raio: number, cor: number): void {
    const anel = new Graphics();
    anel.circle(0, 0, raio + 4).stroke({ color: cor, width: 3, alpha: 0.8 });
    anel.x = x; anel.y = y;
    anel.blendMode = 'add';
    this.pixi.fxLayer.addChild(anel);
    gsap.to(anel.scale, { x: 1.8, y: 1.8, duration: 0.45, ease: 'power2.out' });
    gsap.to(anel, { alpha: 0, duration: 0.45, onComplete: () => destruir(anel) });
  }
}

function destruir(obj: Graphics | Sprite): void {
  if (obj.parent) obj.parent.removeChild(obj);
  obj.destroy();
}
